<template>
  <div class="item-span">
    <div class="item-span" v-if="show">
      <span class="item-link" @click="$emit('on-refresh')">获取建议出价</span>
      <Poptip trigger="hover" placement="top-start" width="410" word-wrap content="请填入本页面所有必填信息后，才能获取到建议出价">
        <Icon type="md-help-circle" size="18" color="#e3e3e3" />
      </Poptip>
    </div>
    <div v-else-if="pricing" class="item-span">
      <span class="c-price c-price-load">
        <Icon type="ios-loading" size="16" class="c-loading" />
        <span>正在计算建议出价...</span>
      </span>
    </div>
    <div v-else class="item-span">
      <span>
        <span
          >建议出价不低于 <font color="#ff6600">{{ value }}</font> 元</span
        >
        <a @click.prevent="$emit('on-refresh')" style="padding-left: 20px">更新</a>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'suggest',
  props: {
    value: {
      type: Number
    },
    pricing: {
      type: Boolean
    }
  },
  computed: {
    show() {
      return !this.value && !this.pricing
    }
  }
}
</script>
<style lang="scss" scoped>
.item-span {
  padding-left: 30px;
  line-height: 32px;
  display: inline-block;
}

.item-link {
  padding-right: 8px;
  cursor: pointer;
  color: #598fe6;
}

.c-loading {
  animation: ani-demo-spin 1s linear infinite;
}
</style>
